import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppContextService } from '@portal/shared/services/app-context.service';

@Injectable({
    providedIn: 'root',
})
export class AppContextPartiesGuard  {
    constructor(
        private readonly _appContextService: AppContextService,
        private readonly _router: Router,
    ) {
    }

    canActivate(): boolean | UrlTree {
        const defaultRoute = this._appContextService.defaultRoute();

        return defaultRoute === '/parties'
            ? true
            : this._router.parseUrl(defaultRoute);
    }
}
